/// <reference types="@types/googlemaps" />

const createGoogleMapMarker = ({ OverlayView = google.maps.OverlayView, ...args }) => {
  class GoogleMapMarker extends OverlayView {
    private _position: any;
    private _div?: any;
    private _isSubcribe = false;

    constructor() {
      super();

      this._position = args.position;
      this._div = null;
      this.setMap(args.map);
    }

    draw() {
      const overlayProjection = this.getProjection();
      const position = overlayProjection.fromLatLngToDivPixel(this._position);

      this._div.style.left = position.x + 'px';
      this._div.style.top = position.y + 'px';

      if (!this._isSubcribe) {
        this.subscribeEvents();
      }
    }

    onAdd() {
      const div = document.createElement('div');
      div.classList.add('google-marker');

      this._div = div;

      const panes = this.getPanes() as any;
      panes.overlayImage.appendChild(this._div);
    }

    onRemove() {
      this._div.parentNode.removeChild(this._div);
      this._div = null;
      this.setMap(null);
    }

    markActive() {
      if (this._div) {
        this._div.style.zIndex = 50;
        this._div.classList.toggle('active-google-marker');
      }
    }

    markUnActive() {
      if (this._div) {
        this._div.style.zIndex = 1;
        this._div.classList.toggle('active-google-marker');
      }
    }

    getPosition() {
      return this._position;
    }

    getDraggable() {
      return false;
    }

    unsubscribeEvents() {
      if (this._div) {
        google.maps.event.clearInstanceListeners(this._div);
      }
    }

    private subscribeEvents() {
      google.maps.event.addDomListener(this._div, 'click', (event) => {
        google.maps.event.trigger(this, 'click', event);
        event.preventDefault();
      });

      google.maps.event.addDomListener(this._div, 'mouseenter', (event) => {
        google.maps.event.trigger(this, 'mouseover', event);
        event.preventDefault();
      });

      google.maps.event.addDomListener(this._div, 'mouseleave', (event) => {
        google.maps.event.trigger(this, 'mouseout', event);
        event.preventDefault();
      });

      this._isSubcribe = true;
    }
  }

  return new GoogleMapMarker();
};

export default createGoogleMapMarker;
